import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Cookie } from '@mercadona/mo.library.web-services'
import { DEFAULT_LANGUAGE, LANGUAGES, AVAILABLE_LANGUAGES } from './constants'
import locales from 'locales'
import { changeLanguageCookie } from 'utils/cookies'
import isDebugEnv from 'utils/debug'

const DEBUG = isDebugEnv()
let currentLanguage

function applyTranslations() {
  const nodes = document.querySelectorAll('[i18n]')
  for (let i = nodes.length - 1; i >= 0; i -= 1) {
    const key = nodes[i].getAttribute('i18n')
    const translation = i18n.t(key)
    nodes[i].innerText = translation
  }
}

function changeLanguage(language) {
  i18n.changeLanguage(language, applyTranslations)
  setHtmlLanguage(language)
  changeLanguageCookie(language)
  currentLanguage = language
}

function getAvailableLanguage(language) {
  const available = AVAILABLE_LANGUAGES.includes(language)
  if (!available) {
    return
  }

  return language
}

function getTCLanguage() {
  return currentLanguage || DEFAULT_LANGUAGE
}

function getCurrentLanguage() {
  const lang = window.location.pathname?.split('/')[1]
  if (LANGUAGES.includes(lang)) {
    return lang
  }
  const cookie = Cookie.get(process.env.REACT_APP_USER_INFO)
  if (cookie) {
    return LANGUAGES.includes(cookie.language)
      ? cookie.language
      : DEFAULT_LANGUAGE
  }
  return DEFAULT_LANGUAGE
}

function getLocales() {
  let resources = {}

  for (let i = LANGUAGES.length - 1; i >= 0; i -= 1) {
    const lang = LANGUAGES[i]
    resources[lang] = {
      translation: locales[lang],
    }
  }

  return resources
}

function initialize() {
  currentLanguage = getCurrentLanguage()
  i18n.use(initReactI18next).init(
    {
      resources: getLocales(),
      lng: currentLanguage,
      debug: DEBUG,
    },
    applyTranslations,
  )
  setHtmlLanguage(currentLanguage)
  return i18n
}

function setHtmlLanguage(language) {
  document.documentElement.lang = language
}

export const TranslationService = {
  applyTranslations,
  changeLanguage,
  getAvailableLanguage,
  getCurrentLanguage,
  getTCLanguage,
  initialize,
}
